import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { DataTableFilterMessageService } from '../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { ClaimFilterStateService } from '../../../services/claim-filter-state.service';
import { ClaimMessageService } from '../../../services/claim-message.service';
import { BaseDataTableFilter } from '../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { addFilterStatusToFilterStatusText } from '../../../../../utilities/TableFilterUtility';

@Component({
  selector: 'app-claim-filter-status',
  templateUrl: './claim-filter-status.component.html',
  styleUrls: ['./claim-filter-status.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatSlideToggle
  ]
})
export class ClaimFilterStatusComponent extends BaseDataTableFilter implements OnInit {

  constructor(
    private claimMessageService: ClaimMessageService,
    private filterStateService: ClaimFilterStateService,
    private filterMessageService: DataTableFilterMessageService,
  ) {
    super(filterMessageService)
  }

  ngOnInit(): void {
    if(this.filterStateService.isStatusFilterActive()) {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onApplyClicked(): void {
    if(this.filterStateService.allStatusFiltersDisabled() || this.filterStateService.allStatusFiltersEnabled()) {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
    this.claimMessageService.applyFilter();
  }

  onClearClicked(): void {
    this.filterStateService.resetStatusFilter();
    this.claimMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  onDraftToggled(event: MatSlideToggleChange): void {
    this.filterStateService.statusFilter.draft = event.checked;
  }

  onSubmittedToggled(event: MatSlideToggleChange): void {
    this.filterStateService.statusFilter.submitted = event.checked;
  }

  onCompletedToggled(event: MatSlideToggleChange): void {
    this.filterStateService.statusFilter.completed = event.checked;
  }

  getStateService(): ClaimFilterStateService {
    return this.filterStateService;
  }

  private getFilterStatusText(): any {
    let filterValue: string[] = [];
    addFilterStatusToFilterStatusText("DRAFT", this.filterStateService.isDraftStatusFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("IN PROGRESS", this.filterStateService.isSubmittedStatusFilterActive(), filterValue);
    addFilterStatusToFilterStatusText("COMPLETED", this.filterStateService.isCompletedStatusFilterActive(), filterValue);
    return filterValue;
  }
}